import teamIndusImage from './teaminduslogo.jpg'
const TeamIndusLogo = () => {
  return teamIndusImage
}

export default TeamIndusLogo
